module.exports = __webpack_public_path__ + "img/keno_ball_bottom.0c069514.png";